'use strict';

import React from 'react';
import {browserHistory} from 'react-router';
import AlbumStore from 'stores/AlbumStore';
import AlbumActions from 'actions/AlbumActions';

require('styles/AlbumEdit.scss');

class AlbumEditComponent extends React.Component {
  constructor(props) {
    super(props);
    let albumStore = AlbumStore.getState();
    this.state = {
      album_id: this.props.params.id,
      album: albumStore.album,
      name: albumStore.album.name,
      desc: albumStore.album.desc,
      error: '',
      isAuthor: false
    }
    this.onSave = this.onSave.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onGoBack = this.onGoBack.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.onAlbumChange = this.onAlbumChange.bind(this);
    this.toggleErrorMsgReveal = this.toggleErrorMsgReveal.bind(this);
  }
  componentDidMount() {
    AlbumStore.listen(this.onAlbumChange);
    AlbumActions.cleanAlbumMedia();
    AlbumActions.fetchAlbumDetail(this.props.params.id);

    // Baidu tongji
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    AlbumStore.unlisten(this.onAlbumChange);
  }
  onAlbumChange(state) {
    this.setState({
      album: state.album,
      name: state.album.name,
      desc: state.album.desc,
      isAuthor: state.album.isAuthor
    });
  }
  handleTextChange(event) {
    let state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }
  onSave() {
  	if(!this.state.name){
  	  this.setState({
  		error: "合辑标题不能为空"
  	  });
  	  return;
  	}
  	AlbumActions.updateAlbum({
  	  album_id: this.state.album_id,
  	  name: this.state.name,
  	  desc: this.state.desc
  	});
  }
  toggleErrorMsgReveal() {
   	this.setState({
  	  error: ""
  	});
  }
  onGoBack() {
  	browserHistory.goBack();
  }
  onClear() {
  	this.setState({
  	  name:"",
  	  desc:""
  	});
  }
  render(){
  	let errorMsgReveal;
    	if(this.state.error){
    	  errorMsgReveal=(
          <div className="text-center error-msg" >
            <button className="close-btn" onClick={this.toggleErrorMsgReveal} aria-label="Close alert" type="button">
              <span aria-hidden="true">×</span>
            </button>
            {this.state.error}
          </div>
        );
    	}
  	return (
  	  <div className="album-edit-component">
  	    <div className="row align-center header">
          <a className="columns text-white text-left small-3 pl-15" onClick={this.onGoBack}>返回</a>
          <span className="title columns small-6 text-center">
            {this.state.album.name}({this.state.album.media_amount})
          </span>
          <a className='pr-15 columns small-3 text-white text-right' onClick={this.onClear}>重置</a>
        </div>
        <div className="form">
  	      <div className="columns">
            <input type="text" placeholder="完善合辑标题" name='name' value={this.state.name} onChange={this.handleTextChange}/>
  	      </div>
  	      <div className="columns">
  	        <textarea className="desc" name='desc' onChange={this.handleTextChange} placeholder="快来完善合辑简介～～" value={this.state.desc}></textarea>
  	      </div>
  	      <div className="columns">
  		    {errorMsgReveal}
  	      </div>
  	      <div className="columns">
  	        <button className="button save" onClick={this.onSave}>保存</button>
  	      </div>
        </div>
  	  </div>
  	);
  }
}

AlbumEditComponent.displayName = 'AlbumEditComponent';

export default AlbumEditComponent;



// WEBPACK FOOTER //
// ./src/components/AlbumEditComponent.js